(function () {
  'use strict';

  if (window.ShoevBenefitsGuide) {
    window.ShoevBenefitsGuide.init(document);
    return;
  }

  class ShoevBenefitsController {
    constructor(root) {
      this.root = root;
      this.choices = Array.from(root.querySelectorAll('[data-benefit-choices] button'));
      this.cards = Array.from(root.querySelectorAll('[data-product-model]'));
      this.track = root.querySelector('[data-benefit-products]');
      this.onChoiceClick = this.onChoiceClick.bind(this);
      this.onChoiceKeydown = this.onChoiceKeydown.bind(this);

      this.choices.forEach((choice) => {
        choice.addEventListener('click', this.onChoiceClick);
        choice.addEventListener('keydown', this.onChoiceKeydown);
      });

    }

    onChoiceClick(event) {
      this.selectModel(event.currentTarget);
    }

    onChoiceKeydown(event) {
      const currentIndex = this.choices.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.choices.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.choices.length) % this.choices.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.choices.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.choices[nextIndex].focus();
      this.selectModel(this.choices[nextIndex]);
    }

    selectModel(choice) {
      const model = choice.dataset.model;
      const selectedCard = this.cards.find((card) => card.dataset.productModel === model);

      this.choices.forEach((item) => {
        item.setAttribute('aria-pressed', String(item === choice));
      });
      this.cards.forEach((card) => {
        const isSelected = card === selectedCard;

        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-current', String(isSelected));
        card.setAttribute('aria-hidden', 'false');
      });

      if (selectedCard && window.matchMedia('(max-width: 749px)').matches && this.track) {
        const targetLeft = Math.max(0, selectedCard.offsetLeft - ((this.track.clientWidth - selectedCard.clientWidth) / 2));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: targetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

    }

    destroy() {
      this.choices.forEach((choice) => {
        choice.removeEventListener('click', this.onChoiceClick);
        choice.removeEventListener('keydown', this.onChoiceKeydown);
      });
      delete this.root.shoevBenefitsController;
    }
  }

  const guide = {
    init(scope) {
      scope.querySelectorAll('[data-shoev-benefits]').forEach((root) => {
        if (!root.shoevBenefitsController) {
          root.shoevBenefitsController = new ShoevBenefitsController(root);
        }
      });
    },
    destroy(scope) {
      scope.querySelectorAll('[data-shoev-benefits]').forEach((root) => {
        if (root.shoevBenefitsController) root.shoevBenefitsController.destroy();
      });
    }
  };

  window.ShoevBenefitsGuide = guide;
  guide.init(document);

  document.addEventListener('shopify:section:load', (event) => guide.init(event.target));
  document.addEventListener('shopify:section:unload', (event) => guide.destroy(event.target));
}());
